import styled from 'styled-components';

/**
 * Akcja stanu błędu jako drobny link. Kolorowy przycisk sugerował sprawczość,
 * której użytkownik nie ma — może tylko ponowić próbę albo się cofnąć.
 */
export const LinkAction = styled.button<{ $muted?: boolean }>`
  padding: 4px 2px;
  font-size: 13px;
  font-weight: 500;
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 3px;
  transition: color 0.2s ease;
  color: ${({ theme, $muted }) => {
    if ($muted) return theme.mode === 'dark' ? '#9ca3af' : '#6b7280';
    return theme.mode === 'dark' ? '#f3f4f6' : '#111827';
  }};

  &:hover:not(:disabled) {
    color: ${({ theme }) => (theme.mode === 'dark' ? '#ffffff' : '#000000')};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    text-decoration: none;
  }
`;
